import { areBothMissing } from "../../../../utils/line-item-matchers/shared.js";
const opticalParametersOnServer = [
  "baseCurve",
  "diameter",
  "power",
  "axis",
  "cylinder",
  "addition",
  "pupillaryDistance"
];
const areSamePrescriptionParameters = (server, draft) => {
  const serverMap = new Map(Object.entries(server).filter(([k]) => k !== "__typename"));
  for (const attributeName of opticalParametersOnServer) {
    const serverValue = serverMap.get(attributeName);
    const draftValue = draft[attributeName];
    if (areBothMissing(serverValue, draftValue)) {
      serverMap.delete(attributeName);
      continue;
    }
    if (serverValue !== draftValue) {
      return false;
    }
    serverMap.delete(attributeName);
  }
  return serverMap.size <= 0;
};
export {
  areSamePrescriptionParameters
};
//# sourceMappingURL=prescription-parameters.js.map
